import React, {useRef, useEffect} from 'react';
import {Animated, StyleSheet, Platform, View, Dimensions} from 'react-native';
import {SkillzText} from '@skillz/ui';
import ThemeOverrideProps from 'ThemeOverrideProps';
import {DepositSuccessModalDeposit} from 'DepositSuccessModal';
import LottieView from 'lottie-react-native';

const {fontExtraBold} = ThemeOverrideProps.sheetStyles;

type DepositAmountProps = {
  delay?: number;
  deposit: DepositSuccessModalDeposit;
};

const DepositAmount = ({delay = 1500, deposit}: DepositAmountProps) => {
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const translateY = useRef(new Animated.Value(100)).current;
  const lottieRef = useRef<LottieView>(null);
  const isIOS = Platform.OS === 'ios';
  const width = Dimensions.get('window').width;
  const lottieFilePrefix = '../../../../../../../source_images/lottieAnimations/';

  const lottieFileIOS = require(`${lottieFilePrefix}/deposit_success_checkmark_ios.json`);
  const lottieFileAndroid = require(`${lottieFilePrefix}/deposit_success_checkmark_android.json`);

  const extraDelay = 500;

  useEffect(() => {
    Animated.parallel([
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 500,
        delay: delay + extraDelay,
        useNativeDriver: true,
      }),
      Animated.timing(translateY, {
        toValue: 0,
        duration: 500,
        delay: delay + extraDelay,
        useNativeDriver: true,
      }),
    ]).start();
  }, [fadeAnim, translateY, delay]);

  const styles = stylesfn(width);

  return (
    <View style={styles.container}>
      <LottieView
        source={isIOS ? lottieFileIOS : lottieFileAndroid}
        loop={false}
        autoPlay
        speed={0.8}
        style={isIOS ? styles.lottieAnimation : styles.lottieAnimationAndroid}
        ref={lottieRef}
      />

      <Animated.View style={[styles.container, {opacity: fadeAnim, transform: [{translateY}]}]}>
        <SkillzText style={styles.depositAmountText}>${deposit.depositAmount}</SkillzText>
        <SkillzText style={styles.depositSuccessfulText}>Deposit Successful</SkillzText>
      </Animated.View>
    </View>
  );
};

const stylesfn = (width: number) =>
  StyleSheet.create({
    container: {
      alignItems: 'center',
      flexDirection: 'column',
      paddingTop: 20,
    },
    lottieContainer: {
      position: 'absolute',
      width: '100%',
      zIndex: 10000,
    },

    lottieAnimation: {
      position: 'absolute',
      width: '100%',
      top: -52,
      zIndex: 10000,
    },

    lottieAnimationAndroid: {
      position: 'absolute',
      width: width,
      height: width * 1.2,
      top: -40,
      zIndex: 1000,
    },

    checkMarkIcon: {
      width: 50,
      height: 50,
      zIndex: 2,
    },

    depositAmountText: {
      fontSize: 45,
      ...fontExtraBold,
      color: '#08B45C',
      zIndex: 2,
    },

    depositSuccessfulText: {
      fontSize: 20,
      ...fontExtraBold,
      color: '#08B45C',
      zIndex: 2,
    },
  });

export default DepositAmount;
